import request from './request';

export const getMyEnterpriseProfile = () => request.get('/enterprises/my/profile');
export const updateMyEnterpriseProfile = (payload) => request.put('/enterprises/my/profile', payload);
export const getAdminEnterpriseList = () => request.get('/enterprises/admin/list');
